<template>
	<div class="wrap">
		<div class="wrapLeft"  >
			<div class="content-html" v-resize="resize" v-loading="loading">
				<quill-editor
				  ref="myQuillEditor"
				  v-model="transHtml"
				  :style="'height:' + height"
				  :options="editorOption"
				  @blur="onEditorBlur($event)"
				  @focus="onEditorFocus($event)"
				  @ready="onEditorReady($event)"
				  @change="onEditorChange($event)"
				/>
			</div>
			
			<div class="bottom-button">
				<el-button type="primary" @click="getUpdateDoc()">修改文章</el-button>
			</div>
		</div>
		<div class="wrapRight">
			<div class="sourceUrl" >
				<h3 >来源：</h3>
				<p ><a :href="sourceUrl" target="_black">{{sourceUrl}}</a></p>
			</div>
			<el-form ref="form" label-width="120px">
				<el-form-item label="选择文章归类">
					<el-checkbox-group v-model="sort">
						<el-checkbox v-for="item in sortList" :key="item.id" :label="item.id">{{item.name}}
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="选择文章下架">
					<el-checkbox-group v-model="out">
						<el-checkbox v-for="item in outList" :key="item.id" :label="item.id" :disabled="docFiery==1?true:false">{{item.name}}</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="选择收费模式">
					<el-radio v-model="checkedCost" label="1">免费</el-radio>
					<el-radio v-model="checkedCost" label="2">会员</el-radio>
					<el-radio v-model="checkedCost" label="3">隐藏文章</el-radio>
				</el-form-item>
				<el-form-item label="选择频道">
					<el-checkbox-group v-model="channelId">
						<span v-for="item in channel" :key="item.id" class="tooltip" style="margin-right: 10px;">
							<el-tooltip class="item" effect="dark" placement="top-start" >
								 <div slot="content">
									 <span v-for="(v,i) in item.descriptionArry" :key="i">
										 {{v}}<br/>
									 </span>
								 </div>
							    <el-checkbox  :label="item.id" >
							    	 {{item.name}}
							    </el-checkbox>
							</el-tooltip>
						</span>
						
					</el-checkbox-group>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="onSubmit">下一篇</el-button>
					<span class="totalCount">剩余{{noNavCount}}篇</span>
				</el-form-item>
			</el-form>
		</div>
	</div>
	
</template>

<script>
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";
	
	// html显示（富文本插件）
	import { quillEditor } from "vue-quill-editor";
	import {
		detailNoNav,
		ywDetails,
		navList,
		soldOutList,
		sortSave,
		updateDoc,
		selectAllList
	} from "@/network/mochaItom/index.js"
	const toolbarOptions = [
	    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
	    ['blockquote', 'code-block'],
	    [{ 'header': 1 }, { 'header': 2 }], // custom button values
	    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
	    [{ 'script': 'sub' }, { 'script': 'super' }], // superscript/subscript
	    [{ 'indent': '-1' }, { 'indent': '+1' }], // outdent/indent
	    [{ 'align': [] }],
	    ['link', 'image','video'],
	    ['clean'] // remove formatting button
	];
	
	
	export default {
		components: {
		  quillEditor,
		},
		data() {
			return {	
				height: '',
				editorOption: {
				  placeholder: "编辑文章内容",
			// 	  theme: 'snow', // or 'bubble'
			// 		  modules: {
			// 			  toolbar: {
			// 				  container: toolbarOptions, // 工具栏
			// 				  handlers: {
			// 					  'image':  (value)=> {
			// 						  if (value) {
			// 							  // 触发input框选择图片文件
			// 							  this.uploadSuccess();
			// 							  // document.querySelector('.avatar-uploader1 input').click()
			// 						  } else {
			// 							  this.quill.format('image', false);
			// 						  }
			// 					  }
			// 				  }
			// 			  }
			// 		  }
	  
				 
				},
				transHtml: "",
				sortList: [],//文章归类
				outList: [], //下架原因
				noNavCount: 0, //剩余多少篇
				sort: [],
				out: [],
				docId:"",
				loading:true,
				sourceUrl:"",//文章来源
				isEdit:false,
				divResize:"",
				docFiery:"" ,//1下架
				channel:[],
				channelId:[],
				checkedCost:"1",
			}
		},
		computed: {
			//计算属性 , 设置iframe高度为窗口高度少100px
			calHeight() {
				return (window.innerHeight - 100) + 'px';
			}
		},
		directives: {  // 使用局部注册指令的方式
		  resize: { // 指令的名称
		    bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
		      let width = '', height = '';
		      function isReize() {
		        const style = document.defaultView.getComputedStyle(el);
				// console.log(style)
		        if (width !== style.width || height !== style.height) {
		          binding.value(style.height);  // 关键
		        }
		        width = style.width;
		        height = style.height;
		      }
		      el.__vueSetInterval__ = setInterval(isReize, 300);
		    },
		    unbind(el) {
		      clearInterval(el.__vueSetInterval__);
		    }
		  }
		},
		created() {
			this.getDetailNoNav()
			this.getNavList()
			this.getSoldOutList()
			this.getSelectAllList()
		},
		methods: {
			resize(data) {  // 当宽高变化时就会执行
			  //执行某些操作
			  let height = data.slice(0,data.length-2)-100 + "px"
			  this.height = height;
			},
			getSoldOutList() { //下架原因
				soldOutList({
					type: 'operation'
				}).then(res => {
					if (res.data.code == 200) {
						this.outList = res.data.data;
					}
				})
			},
			getNavList() { //文章分类
				navList().then(res => {
					if (res.data.code == 200) {
						this.sortList = res.data.data;
					}
				})
			},
			getDetailNoNav() { //获取文章id
				this.loading = true;
				detailNoNav().then(res => {
					if (res.data.code == 200) {
						this.noNavCount = res.data.data.noNavCount;
						this.docId = res.data.data.id;
						
						this.getArticleDetail(res.data.data.id);
					}
				})
			},
			getArticleDetail(detailId) { //文章详情
				ywDetails({
					docId: detailId,
				}).then(res => {
					if (res.data.code == 200) {
						var data = res.data.data
						if (!data.transHtml && !data.transMd) {
							this.$message('暂无数据');
						}
						this.docFiery = data.docFiery;
						this.sourceUrl = data.sourceUrl;
						this.transHtml = data.transHtml;
						this.channelId = res.data.data.channelIds;
						this.loading = false;
					}
				}).catch(err => {

				})
			},
			getSortSave(){//保存分类
				sortSave({
					docId: this.docId,
					navigations: this.sort.toString(),
					reason: this.out.toString(),
					channel:this.channelId,
					docVip:this.checkedCost
				}).then(res => {
					if (res.data.code == 200) {
						this.$message.success('保存成功');
						this.sort = [];
						this.out = [];
						this.channelId = [];
						this.getDetailNoNav()
					}
				}).catch(err => {
				
				})
			},
			getUpdateDoc(){ //更新文章内容
			    let transHtmlStart = '<!DOCTYPE html><html><head><meta charset="utf-8" /><meta name="viewport" content="width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no" /></head><body>';
				let transHtmlEnd = '</body></html>'
				updateDoc({
					id: this.docId,
					transHtml:transHtmlStart + this.transHtml + transHtmlEnd
				}).then(res => {
					if (res.data.code == 200) {
						this.$message.success('修改成功');
					}
				}).catch(err => {
				
				})
			},
			getSelectAllList(){
				selectAllList().then(res=>{
					if (res.data.code == 200) {
						res.data.data.forEach(res=>{
							let description = res.description;
							let descriptionArry = [];
							let length = description.length;
							let num = 20;
							if(length>0){
								length = Math.ceil(length/num);
								for(let i =0;i<length;i++){
									descriptionArry.push(res.description.substr(i*num,num))
								}
							}
							res.descriptionArry = descriptionArry;
						})
						this.channel = res.data.data;
					}
				})
			},
			onSubmit() { //点击事件
				if(this.sort.length==0){
					this.$message('请至少选择一个分类');
				}else{
					this.getSortSave();
				}
			},
			// 编辑器的方法
			onEditorReady(quill) {
			  console.log("editor ready!");
			},
			onEditorFocus(quill) {
			  this.isEdit = true;
			  console.log("editor focus!");
			},
			onEditorChange({ quill, html, text }) {
			  // console.log('editor change!', quill, html, text)
			  this.transHtml = html;
			},
			onEditorBlur(quill) {
			  console.log("editor blur!", quill);
			},
			uploadSuccess(res, file) {
				// res为图片服务器返回的数据
				// 获取富文本组件实例
				let quill = this.$refs.myQuillEditor.quill;
				let length = quill.getSelection().index;
				// 插入图片  res.info为服务器返回的图片地址
				quill.insertEmbed(length, 'image', 'https://img1.baidu.com/it/u=413643897,2296924942&fm=253&app=138&size=w931&n=0&f=JPEG&fmt=auto?sec=1682182800&t=4c1a734028d300bdde9de4de04b49286')
				// 调整光标到最后
				quill.setSelection(length + 1)
				// 如果上传成功
				// if (res.code === 200) {
				// 	// 获取光标所在位置
				// 	let length = quill.getSelection().index;
				// 	// 插入图片  res.info为服务器返回的图片地址
				// 	quill.insertEmbed(length, 'image', res.data.link)
				// 	// 调整光标到最后
				// 	quill.setSelection(length + 1)
				// 	this.$forceupdate() 
				// } else {
				// 	this.$message.error('图片插入失败')
				// }
				// loading动画消失
				this.quillUpdateImg = false;
			},
		}
	}
</script>
<style scoped="scoped" lang="scss">
	.wrap {
        display: flex;
		flex-direction: row !important;
		height: 100%;
		>div {
			box-sizing: border-box;
			padding: 20PX;
		}

		.wrapLeft {
			width: 900px;
			height: 100%;
			display: flex;
			background-color: #ffffff;
			border: 1px solid #eee;
			overflow-y: auto;
			overflow-x: hidden;
			flex-direction: column;
			/deep/ div,/deep/ p{
				width: 100% !important;
			}
			/deep/img{
				width: 860px;
				margin: 20px 0;
			}
			.content-html{
				flex: 1;
				display: flex;
			}
			.bottom-button{
				height: 100PX;
				width: 100%;
				display: flex;
				align-items: center;
			}
		}

		.wrapRight {
			flex: 1;
			background-color: #ffffff;
			.sourceUrl{
				display: flex;
				flex-direction: row;
				align-items: center;
				h3{
					width: 60PX;
					font-size: 15px;
					color: #666;
					font-weight: 400;
				}
				p{
					flex: 1;
					word-break:break-all;
					a{
						font-size: 14px;
						color: #409EFF;
					}
				}
			}
			/deep/.el-form-item__label{
				text-align: left;
			}
			.tooltip{
				margin-right: 30px;
				
			}
		}

		// ::-webkit-scrollbar {
		// 	width: 0 !important;
		// }

		// ::-webkit-scrollbar {
		// 	width: 0 !important;
		// 	height: 0;
		// }

		.totalCount {
			font-size: 14px;
			color: #a7a7a7;
			margin-left: 10px;
		}

	}
	
</style>
